const body = document.querySelector('body')
const mobileMenuButton = document.getElementById('main_nav_button')
const mainNav = document.getElementById('main_nav')
const header_menus = document.getElementById('header_menus')

let mobileMenuIsTransitioning = null
let listItemsWithChildren = null
let listItems = null


const init = function() {

	if ( mainNav !== null ) {

		listItemsWithChildren = mainNav.querySelectorAll('.menu-item-has-children');
		listItems = header_menus.querySelectorAll('.header__main-menu > li:not(.menu-item-has-children)');

		setupSubmenuToggling();
		setupMobileMenuButton();

        // Escape key closes menu
        window.addEventListener('keyup', (e) => {
            if ( e.key === 'Escape' || e.key === 'Esc' ) { // deprecated: e.keyCode === 27
                toggleMobileMenu( 'hide' )
                hideAllSubmenus()
                e.preventDefault()
                return false
            }
        }, true )

	}

};


const toggleMobileMenu = function( forceState ) {

	if ( mobileMenuIsTransitioning !== null ) return;

	const bodyOverlayClass = 'has-mute-overlay';
	const bodyOverlayVisibleClass = 'has-visible-overlay';
	let 	menuStateToActivate = ( body.classList.contains(bodyOverlayClass) ) ? 'hide' : 'show';

	if ( forceState === 'hide' ) menuStateToActivate = 'hide';

	if ( menuStateToActivate === 'show' ) {

		// add body class to trigger mute overlay
		body.classList.add(bodyOverlayClass);
		mobileMenuButton.setAttribute('aria-expanded', 'true');
		header_menus.classList.add('has-entered');

		mobileMenuIsTransitioning = setTimeout( () => {
			header_menus.classList.add('is-visible');
			body.classList.add(bodyOverlayVisibleClass);
			mobileMenuIsTransitioning = null;
		}, 100 );

	} else {

		body.classList.remove(bodyOverlayVisibleClass);
		mobileMenuButton.setAttribute('aria-expanded', 'false');
		header_menus.classList.remove('is-visible');

		mobileMenuIsTransitioning = setTimeout( () => {
			header_menus.classList.remove('has-entered');
			body.classList.remove(bodyOverlayClass);
			mobileMenuIsTransitioning = null;
		}, 400 );

	}

};


const setupMobileMenuButton = function() {

	mobileMenuButton.addEventListener('click', toggleMobileMenu);

};


const setupSubmenuToggling = function() {

    if ( listItems ) {
        listItems.forEach( item => {
            
            item.addEventListener( 'mouseenter', ( event ) => {
                if ( window.innerWidth >= 950 ) hideAllSubmenus()
            } )
            
            item.querySelector('a').addEventListener( 'focus', ( event ) => {
                hideAllSubmenus()
            } )

        } )
    }

    if ( listItemsWithChildren ) {
        listItemsWithChildren.forEach( item => {

            let menuTimer = null
            const button = item.querySelector( 'button' )
    
            item.addEventListener( 'mouseenter', () => {
                if ( window.innerWidth >= 950 ) showDesktopSubmenu( item, menuTimer )
            } )
            
            button.addEventListener( 'click', () => {
                if ( button.getAttribute('aria-expanded') === 'true' && window.innerWidth < 950 ) {
                    hideAllSubmenus()
                } else {
                    showDesktopSubmenu( item, menuTimer )
                }
            } )
    
            item.addEventListener( 'mouseout', ( event ) => {
                if ( window.innerWidth >= 950 ) {
                    if ( item.contains( event.relatedTarget ) ) return
                    menuTimer = setTimeout( () => hideDesktopSubmenu( item ), 600 )    
                }
            } )
    
        });
    }

};


const showDesktopSubmenu = function( item, timer ) {

    clearTimeout( timer )
    
    hideAllSubmenus()
    
    item.querySelector( 'button' ).setAttribute( 'aria-expanded', 'true' )

}


const hideAllSubmenus = function() {

    if ( listItemsWithChildren ) listItemsWithChildren.forEach( item => { hideDesktopSubmenu( item ) } )

}


const hideDesktopSubmenu = function( item ) {
    
    item.querySelector( 'button' ).setAttribute( 'aria-expanded', 'false' )

}


const api = {
	init: init
};

export default api;